export enum Currency {
  USD = 'usd',
  EUR = 'eur',
}
